import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

import { AccountService } from 'app/core';
import { Engagement } from './engagements.types';
import { Account } from 'app/core/models';
import { RelatedToType } from '@shared/enums';

@Injectable({
  providedIn: 'root',
})
export class EngagementsService {
  private account: Account;
  constructor(
    private _httpClient: HttpClient,
    private readonly accountService: AccountService,
  ) {
    this.accountService.currentAccount.subscribe((accountData) => {
      this.account = accountData;
    });
  }

  getEngagementById(id: number): Observable<Engagement> {
    return this._httpClient.get<any>(`engagements/${id}`);
  }

  getEngagementByContactId(id: number): Observable<any> {
    return this._httpClient.get<any>(`engagements?contact_id=${id}`);
  }

  getEngagementByCompanyId(id: number): Observable<any> {
    return this._httpClient.get<any>(`engagements?company_id=${id}`);
  }

  getEngagements(id: number, relatedToType: RelatedToType): Observable<Engagement[]> {
    if (relatedToType === RelatedToType.Contact || relatedToType === RelatedToType.Company) {
      return this._httpClient
        .get<any>(`engagements?${relatedToType.toLowerCase()}_id=${id}`)
        .pipe(map((response) => response.engagements));
    }

    return this._httpClient
      .get<any>(`engagements?related_to_type=${relatedToType.toLowerCase()}&related_to_id=${id}`)
      .pipe(map((response) => response.engagements));
  }

  createEngagement(engagement: Engagement): Observable<Engagement> {
    return this._httpClient
      .post<{ engagement: Engagement }>(`engagements`, { engagement })
      .pipe(map(({ engagement }) => engagement));
  }

  updateEngagement(engagement: Engagement): Observable<Engagement> {
    return this._httpClient
      .put<{ engagement: Engagement }>(`engagements/${engagement.id}`, { engagement })
      .pipe(map(({ engagement }) => engagement));
  }

  deleteEngagement(id: number): Observable<void> {
    return this._httpClient.delete<void>(`engagements/${id}`);
  }
}
